import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "services-grid" }

import { motion } from "motion-v"
import BaseSection from "@/views/sections/BaseSection.vue"
import GradientTitle from "@/components/GradientTitle.vue"
import FeatureCard from "@/components/FeatureCard.vue"
import CallToActionSection from "@/components/CallToActionSection.vue"


export default /*@__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  setup(__props) {

const services = [
  {
    title: 'Neue Features für deine App',
    description: 'Ich erweitere deine bestehende Laravel/Vue Applikation um neue Features – sauber integriert, getestet und ohne Tech-Debt aufzubauen.',
    icon: 'laravel-original.svg'
  },
  {
    title: 'GitLab Pipeline Optimierung',
    description: 'Ich räume eure CI/CD-Prozesse auf. Schnellere Builds, automatisierte Tests und stressfreie Deployments über GitLab CI.',
    icon: 'gitlab-plain.svg'
  },
  {
    title: 'Dockerisierung',
    description: 'Vom lokalen Setup bis zur Produktion: Ich dockerisiere eure Anwendungen, damit das \'Works on my machine\'-Problem endgültig verschwindet.',
    icon: 'docker-plain.svg'
  }
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseSection, { "background-style": "dark" }, {
    default: _withCtx(() => [
      _createVNode(_unref(motion).div, {
        class: "services-header",
        initial: { opacity: 0, y: 30 },
        whileInView: { opacity: 1, y: 0 },
        transition: { duration: 0.6 },
        inViewOptions: { once: true }
      }, {
        default: _withCtx(() => [
          _createVNode(GradientTitle, {
            text: "Wie kann ich dir helfen?",
            tag: "h2"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("p", { class: "services-subtitle" }, "Professionelle Unterstützung für deine Entwicklungsprojekte", -1))
        ]),
        _: 1,
        __: [0]
      }),
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(services, (service, index) => {
          return _createVNode(FeatureCard, {
            key: service.title,
            title: service.title,
            description: service.description,
            icon: service.icon,
            index: index
          }, null, 8, ["title", "description", "icon", "index"])
        }), 64))
      ]),
      _createVNode(CallToActionSection)
    ]),
    _: 1
  }))
}
}

})